import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from '../containers/NewHome';
import Login from '../containers/NewHome/components/Login';
import OtpModal from '../containers/NewHome/components/OtpModal';
import SignUp from '../containers/NewHome/components/SignUp';
import PhoneModal from '../containers/NewHome/components/PhoneModal/Index';
import AssessmentModal from '../containers/NewHome/components/Assessment';
import SuccessModal from '../containers/NewHome/components/SuccessModal';
import WaitList from '../containers/NewHome/components/WaitList';
import { useModal } from '../context/ModalContext';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../constants/app';
import Modal from '../containers/NewHome/components/Modal';
import { getItem, removeItem } from '../utils/cache';
import ResetPasswordModal from '../containers/NewHome/components/ResetPasswordModal';
import ResetPasswordOtpModal from '../containers/NewHome/components/ResetPasswordModal/ResetPasswordOtpModal';
import ConfirmPhoneModal from '../containers/NewHome/components/PhoneModal/ConfirmPhoneModal';
import AddEmailModal from '../containers/NewHome/components/EmailModal/AddEmailModal';
import ConfirmEmailModal from '../containers/NewHome/components/EmailModal/ConfirmEmailModal';
import EmailOtpModal from '../containers/NewHome/components/EmailModal/EmailOtpModal';
import ChangePasswordModal from '../containers/NewHome/components/ResetPasswordModal/ResetPassword';
import EmailModal from '../containers/NewHome/components/EmailModal';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { APP_ROUTES } from '../route';
import { extractJSON } from '../services/jsonUtil';
import { useCourseDetail } from '../hooks/useCourseDetail';
import { useDispatch } from 'react-redux';
import {
  doCreateOrderRequest,
  doOfflineCartRequest,
} from '../store/action/checkout';
import { getCartInfoRequest } from '../api/checkout';
import { getUserAttribute } from '../utils/helpers';
import Loader from '../ui-core/Loader';
import NameModal from '../containers/NewHome/components/SignUp/NameModal';

const GlobalModalManager = ({ countryCode = 'us' }) => {
  const history = useHistory();
  const localMatch = extractJSON('localMatch');
  const { handleCourseRedirection } = useCourseDetail(history, localMatch);
  const {
    modalState,
    modalProps,
    closeModal,
    openModal,
    handleGlobalModalState,
  } = useModal();

  const dispatch = useDispatch();
  const [isLoaderShow, setIsLoaderShow] = useState(false);

  const fetchCartData = async () => {
    return await getCartInfoRequest();
  };

  const processOfflineCart = async () => {
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    const OfflineCartData = JSON.parse(getItem('offlineCart'));

    if (!!user && OfflineCartData?.length) {
      setIsLoaderShow(true);
      for (const item of OfflineCartData || []) {
        const product = {
          ...item?.attributes,
          id: item?.attributes?.product_id,
        };

        await dispatch(doOfflineCartRequest({ product }));
        await new Promise(resolve => {
          setTimeout(resolve, 500);
        });
      }
      setIsLoaderShow(false);

      fetchCartData();
      dispatch(doCreateOrderRequest());
      removeItem('offlineCart');
      removeItem('checkoutFromSignup');
      removeItem('isOfflineCheckout');
    }
  };

  const handleClose = () => {
    const mergePhoneDetails = JSON.parse(getItem('mergePhoneDetail'));
    const onboardingCompleted = extractJSON('completeOnboarding');
    const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
    const coursePageRedirectUrl = extractJSON('coursePageRedirectUrl');
    const isOfflineCheckout = JSON.parse(getItem('isOfflineCheckout'));
    const isOnboardingCompleted = getUserAttribute('onboarding_completed');
    const isFromLogin = getItem('isFromLogin');
    const isRedirectCourse = getItem('redirectToCourse');
    const localUser = extractJSON(LOCAL_STORAGE_CONSTANT.USER);

    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
    // removeItem('completeOnboarding'); // commented for testing purpose
    removeItem('AccountMerge');

    if (modalState === MODAL_TYPE.NAME) {
      handleGlobalModalState(null);
      closeModal();
    }

    if ([MODAL_TYPE.LOGIN, MODAL_TYPE.SIGNUP].includes(modalState)) {
      removeItem('isOfflineCheckout');
    }
    if (MODAL_TYPE.ASSESSMENT === modalState) {
      const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
      if (user) {
        if (coursePageRedirectUrl) {
          history.push(coursePageRedirectUrl);
        } else {
          history.push(APP_ROUTES.HOME);
        }
      }
    }
    if (modalState === MODAL_TYPE.EMAIL_OTP) {
      // JW-261
      handleGlobalModalState(false);
      history.push(APP_ROUTES?.HOME);
    }

    // Added due to JW-283
    if (isOfflineCheckout) {
      processOfflineCart();
    } else if (isOnboardingCompleted) {
      history?.push(APP_ROUTES.HOME);
    } else if (!isOnboardingCompleted && !isRedirectCourse) {
      // handleModalState(MODAL_TYPE.ASSESSMENT);
      history?.push(APP_ROUTES.SIGNUP_ONBOARDING);
      closeModal();
    } else {
      history?.push(APP_ROUTES.HOME);
      closeModal();
    }

    // Added due to JW-283
    if (
      !isOfflineCheckout &&
      !isRedirectCourse &&
      modalState === MODAL_TYPE.OTP &&
      mergePhoneDetails
    ) {
      history.push(APP_ROUTES.HOME);
      closeModal();
    }

    if (session) {
      if (isRedirectCourse) {
        if (localUser?.attributes?.new_user && isFromLogin === 'false') {
          handleGlobalModalState(MODAL_TYPE.NAME);
        } else {
          if (
            modalState !== MODAL_TYPE.LOGIN &&
            modalState !== MODAL_TYPE.SIGNUP &&
            !(
              modalState === 'isEmailLogin' &&
              localUser?.attributes?.mobile === ''
            )
          ) {
            handleCourseRedirection();
          }
        }
      }
      if (session && onboardingCompleted) {
        history.push(APP_ROUTES.ASSESSMENT_ONBOARDING);
        closeModal();
      }
    }

    removeItem('redirectToCourse');
    removeItem('localMatch');
    removeItem('localSlug');

    // closeModal();
  };

  const renderModalContent = () => {
    const commonProps = {
      countryCode,
      ...modalProps,
      handleModalEvent: openModal,
      handleModalState: openModal,
    };

    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState}>
            <Login {...commonProps} />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState}>
            <OtpModal {...commonProps} handleClose={handleClose} />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState}>
            <SignUp {...commonProps} />
          </Wrapper>
        );
      case MODAL_TYPE.PHONE:
        return (
          <Wrapper type={modalState}>
            <PhoneModal {...commonProps} />
          </Wrapper>
        );
      case MODAL_TYPE.ASSESSMENT:
        return (
          <Wrapper type={modalState}>
            <AssessmentModal {...commonProps} handleClose={handleClose} />
          </Wrapper>
        );
      case MODAL_TYPE.SUCCESS:
        return <SuccessModal />;
      case MODAL_TYPE.WAITLIST:
        return <WaitList />;
      case MODAL_TYPE.RESET_PASSWORD:
        return <ResetPasswordModal />;
      case MODAL_TYPE.RESET_OTP:
        return <ResetPasswordOtpModal />;
      case MODAL_TYPE.CONFIRM_PHONE_NUMBER:
        return <ConfirmPhoneModal handleModalState={handleGlobalModalState} />;
      case MODAL_TYPE.CHANGE_PASSWORD:
        return (
          <ChangePasswordModal handleModalState={handleGlobalModalState} />
        );
      case MODAL_TYPE.EMAIL_LOGIN:
        return (
          <EmailModal
            handleModalState={handleGlobalModalState}
            handleClose={handleClose}
          />
        );
      case MODAL_TYPE.ADD_EMAIL:
        return <AddEmailModal handleModalState={handleGlobalModalState} />;
      case MODAL_TYPE.CONFIRM_EMAIL:
        return <ConfirmEmailModal handleModalState={handleGlobalModalState} />;
      case MODAL_TYPE.EMAIL_OTP:
        return (
          <EmailOtpModal
            handleModalState={handleGlobalModalState}
            handleClose={handleClose}
          />
        );
      case MODAL_TYPE.NAME:
        return (
          <NameModal
            handleModalState={handleGlobalModalState}
            history={history}
            // match={match}
          />
        );
      default:
        return null;
    }
  };

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      case MODAL_TYPE.NAME:
        return 'sign-onboarding-modal auth-modal my-0 py-4 modal-lg modal-dialog-centered';
      default:
        return undefined;
    }
  })();

  return (
    <>
      <Modal
        dialogClassName={dialogClassName}
        show={Boolean(modalState)}
        handleClose={handleClose}
        blurBackground={true}
        closeButton={
          !(
            modalState === MODAL_TYPE.CONFIRM_PHONE_NUMBER ||
            modalState === MODAL_TYPE.CONFIRM_EMAIL
          )
        }
      >
        {renderModalContent()}
      </Modal>
      <Loader isLoading={isLoaderShow} />
    </>
  );
};

export default GlobalModalManager;

GlobalModalManager.propTypes = {
  countryCode: PropTypes.string,
};
